import React, { useState } from 'react';
import { ExternalLink, Loader2, Palette } from 'lucide-react';
import { toast } from 'sonner';
import { cmsApi, designUrl } from '../../../../lib/api/cms';
import { Button } from '../../../../components/ui/button';
import { Card, CardContent } from '../../../../components/ui/card';

/**
 * Design der Website (Theme-Editor des ThunderBuilders): Farben, Schriften und
 * Ecken für alle Seiten. Der Editor läuft in der Website; hier gibt es wie bei
 * „Seiten gestalten“ (CmsBuilderPage) nur das Übergabe-Token und den Absprung.
 */
const CmsDesignPage: React.FC = () => {
  const [oeffnet, setOeffnet] = useState(false);

  // Fenster sofort öffnen, Ziel erst nach dem Token setzen — sonst blockt der
  // Browser das Popup, weil es nicht mehr direkt am Klick hängt.
  const oeffnen = async () => {
    const fenster = window.open('', '_blank');
    setOeffnet(true);
    try {
      const { token } = await cmsApi.getBuilderUebergabe();
      if (fenster) fenster.location.href = designUrl(token);
      else window.location.href = designUrl(token);
    } catch (e) {
      fenster?.close();
      toast.error(e instanceof Error ? e.message : 'Das Design konnte nicht geöffnet werden');
    } finally {
      setOeffnet(false);
    }
  };

  return (
    <div className="mx-auto max-w-3xl space-y-6 p-4 sm:p-6">
      <div>
        <h1 className="text-2xl font-semibold">Design</h1>
        <p className="text-sm text-muted-foreground">
          Farben, Schriften und Ecken der ganzen Website – mit Vorschau für Handy, Tablet und Desktop und einer Prüfung, ob die
          Schrift auf ihrem Grund lesbar bleibt.
        </p>
      </div>
      <Card>
        <CardContent className="space-y-4 py-6">
          <p className="text-sm">
            Der Editor öffnet sich in einem neuen Tab auf der Website. Nach „Speichern“ sehen Besucher das neue Design spätestens nach
            fünf Minuten. Ohne Änderung bleibt alles, wie es ist.
          </p>
          <Button type="button" onClick={() => void oeffnen()} disabled={oeffnet}>
            {oeffnet ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Palette className="mr-2 h-4 w-4" />}
            Design öffnen
            <ExternalLink className="ml-2 h-3.5 w-3.5" />
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default CmsDesignPage;
